import type { CoachNotification } from '@/features/coach/notifications/types';

/**
 * Where a tapped notification should take the coach, expressed as a tab + nested screen so the
 * caller can hand it straight to `navigation.navigate(tab, { screen, params })`.
 */
export type CoachNotificationRoute =
  | { tab: 'Player'; screen: 'PlayerProfile'; params: { playerId: string } }
  | { tab: 'Home'; screen: 'PlayerProfile'; params: { playerId: string } }
  | { tab: 'Home'; screen: 'Dashboard'; params?: undefined };

/**
 * Maps a notification's `destination` to a screen. Anything unmapped returns `null`, which the
 * caller treats as "mark read and stay on the list" — an unknown destination must never crash or
 * navigate somewhere wrong.
 */
export function resolveCoachNotificationRoute(
  notification: CoachNotification,
): CoachNotificationRoute | null {
  const { destination, playerId } = notification;

  switch (destination) {
    case 'player_profile':
      return playerId ? { tab: 'Player', screen: 'PlayerProfile', params: { playerId } } : null;

    // The coach app has no standalone session/booking detail screen yet, so these land on the
    // dashboard where Up Next lives.
    case 'upnext_session_detail':
    case 'booking_details':
    case 'dashboard':
      return { tab: 'Home', screen: 'Dashboard' };

    default:
      return null;
  }
}
